module.exports = __webpack_public_path__ + "img/79.57563dca.jpg";